<template>
    <div style="width:100%">
        <Date-picker type="daterange" ref="daterange" :value="dateValue" :options="options2"
            :placement="placement||'bottom-start'" :placeholder="placeholder" @on-change="dateChange"
            :disabled="disabled" :transfer="transfer" :clearable="clearable" style="width:100%">
        </Date-picker>
        <input type="text" v-model="dateValue" v-show="false">
    </div>
</template>
<script>
    function getFullTime (value) {
        if (value[0]) {
            value[0] = value[0] + ' 00:00:00'
            value[1] = value[1] + ' 23:59:59'
        }
        return value;
    }
    export default {
        props: {
            value: {
                default () {
                    return []
                }
            },
            placeholder: {
                default: ""
            },
            placement: {
                default: ""
            },
            // 默认日期范围，传天数
            defaultDays: {
                default: ""
            },
            /*是否禁用*/
            disabled: {
                type: Boolean,
                default: false
            },
            transfer: {
                type: Boolean,
                default: false
            },
            /**是否可禁用 */
            clearable: {
                type: Boolean,
                default: true
            },
            /*是否获取带时分秒的日期范围*/
            isFulltime: {
                type: Boolean,
                default: false
            },
            /*是否携带快捷键*/
            isShowOption: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                dateValue: this.value || [],
                options2: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近一个月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近三个月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ]
                }
            }
        },
        watch: {
            value (val) {
                this.dateValue = val;
            },

        },
        created () {
            const defaultDays = this.defaultDays;
            if (defaultDays && !isNaN(defaultDays)) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * parseInt(defaultDays));
                let value = [this.formatDate(start), this.formatDate(end)];
                this.dateValue = value;
                this.$emit('input', this.isFulltime ? getFullTime(value) : value);
                this.$emit('on-change', value)
            }

            if (this.isShowOption) {
                this.options2 = {}
            }

        },
        methods: {
            dateChange (value) {
                this.$emit('input', this.isFulltime ? getFullTime(value) : value);
                this.$emit('on-change', value);
            },
            clear () {
                this.$refs['daterange'].handleClear()
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/common/daterange.vue